module.exports = __webpack_public_path__ + "img/trhot.png";